import { useQuery } from '@tanstack/react-query'
import { raffleService } from '../services/raffleService'

export const useCoupons = (raffleId: string) => {
  return useQuery({
    queryKey: ['coupons', raffleId],
    queryFn: () => raffleService.getCoupons(raffleId),
    enabled: !!raffleId,
  })
}
